import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
import { FaDollarSign, FaUserPlus, FaChartLine } from "react-icons/fa";
import "../styles/Dashboard.css";

import ProductsComponent from "../components/ProductsComponent/ProductsComponent";
import ProductListComponent from "../components/ProductListComponent/ProductListComponent";
import { useSelector, useDispatch } from "react-redux";
import { handleGetProductsList } from "../store/actions/productsListsActions";
import ProductComponent from "../components/ProductComponent/ProductComponent";
import { handleGetTenantData } from "../store/actions/tenantsActions";
import Loader from "../assets/images/loader.gif";

const InputsRequired = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);
  const { tenantData, isLoading } = useSelector((state) => state.tenants);

  // Access productsList from Redux store, renaming it to avoid conflicts
  //const { productsList } = useSelector((state) => state.product);

  const productsList = tenantData?.data?.tenant?.products || [];

  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  useEffect(() => {
    // Fetch tenant data if the user is a superadmin and their ID is available
    if (tenantId) {
      dispatch(handleGetTenantData(tenantId));
    }
  }, [dispatch, tenantId]);

  const productsArray = [
    {
      name: "Maize",
      price: "$50",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
      weight: 5000,
    },
    {
      name: "Maize ",
      price: "$75",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
      weight: 5000,
    },
    {
      name: "Maize ",
      price: "$100",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
      weight: 5000,
    },
    {
      name: "Maize ",
      price: "$100",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
      weight: 5000,
    },
  ];
  const products = [
    {
      name: "Maize ",
      price: "$50",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
    },
    {
      name: "Maize ",
      price: "$75",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
    },
    {
      name: "Maize ",
      price: "$100",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
    },
    {
      name: "Maize ",
      price: "$100",
      imageUrl:
        "https://stage-bagh-e-s3.s3.eu-west-1.amazonaws.com/image-assets/product.png",
    },
  ];

  // Loading state
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <ProductListComponent title="Product List" products={productsList} />
        </Col>

        <Col lg={12} className="component-container mb-2">
          {/* {productsList && productsList.length > 0 ? (
          productsList.map((product) => (
            <ProductComponent key={product.id} product={product} />
          ))
        ) : (
          <p>No products available</p>
        )} */}
          <ProductsComponent
            products={productsArray}
            showFilter={false}
            title="Popular Inputs"
          />
        </Col>

        <Col lg={12} className="component-container mb-2">
          <ProductsComponent products={products} title="Seasonal Inputs" />
        </Col>
      </Row>
    </Container>
  );
};

export default InputsRequired;
